


















































import { Component, Watch } from 'vue-property-decorator';

import { Campaign } from '@/models/marketingCenter/sellCoins';
import {
  StartGuidePreferences,
  StartGuideTask,
  EStartGuideTaskSlug
} from '@/models/start-guide';
import {
  handleTaskTrigger,
  shouldAddSuccessStartGuide
} from '@/utils/start-guide';
import { openCenterModal } from '@/utils/modal';
import { handleDispatchStartGuideHighlight } from '@/utils/start-guide';
import logger from '@/utils/logger';

import Page from '@/componentsV2/molecules/Page/Page.vue';
import eventBus from '@/utils/eventBus';
import RewardsModel from '@/componentsV2/templates/RewardsModel/RewardsModel.vue';

import { ModalOptionsV2 } from '@/components/Modal/ModalOptions';
import { modalMapper } from '@/componentsV2/templates/ModalsDeclaration';

import PerformanceHighlights, {
  defaultPerformanceGraphs,
  defaultPerformanceHighlights
} from '@/componentsV2/templates/PerformanceHighlights/PerformanceHighlights.vue';
import HomeRecomendations from '@/componentsV2/organisms/HomeRecomendations/HomeRecomendations.vue';
import HomeOverview from '@/componentsV2/organisms/HomeOverview/HomeOverview.vue';
import StartGuideNeedHelp from '@/componentsV2/templates/StartGuideNeedHelp/StartGuideNeedHelp.vue';

import BusinessService from '@/api/BusinessService';
import PerformanceUtils, { EPeriodPerformance } from '@/utils/PerformanceUtils';
import { IPeriod } from '@/models/period';
import { IChartSerie } from '@/models/performance';
import CompleteOfferWithImages from '@/components/organisms/Offers/DataPresentation/CompleteOfferWithImages.vue';
import ShopifyExtensionBanner from '@/componentsV2/molecules/ShopifyExtensionBanner/ShopifyExtensionBanner.vue';
import { EOfferStatusEnum, IOfferListItem } from '@/models/offer';
import dayjs from 'dayjs';
import { EBusinessReportType, IBusinessType } from '@/models/business';
import SellCoinsService from '@/api/SellCoinsService';
import ReferralService from '@/api/ReferralService';
import OfferFreeCoinsService from '@/api/OfferFreeCoinsService';
import SpecialCoinOffersService from '@/api/SpecialCoinOffersService';
import SocialRewardsService from '@/api/SocialRewardsService';
import ActivationEmailService from '@/api/ActivationEmailService';
import { mixins } from 'vue-class-component';
import BillingModel from '../Models/BillingModel.vue';
import { IProvider } from '@/models/provider';
import { EBusinessProviders } from '@/components/BusinessTypeSelector/business-providers.enum';

const SHOPIFY_EXTENSION_BANNER_CLOSED =
  '@twism:shopify-extension-banner-closed';

interface ICampaign {
  name: string;
  data: any[];
  hide?: boolean;
}

@Component({
  components: {
    Page,
    PerformanceHighlights,
    HomeRecomendations,
    HomeOverview,
    StartGuideNeedHelp,
    CompleteOfferWithImages,
    ShopifyExtensionBanner
  }
})
export default class Home extends mixins(RewardsModel, BillingModel) {
  overviewData: any = false;

  performanceData: any = {};

  periodActive = EPeriodPerformance.OVERTIME;
  period: IPeriod = PerformanceUtils.defaultPeriod();
  series: IChartSerie[] = [];
  chartLoading = false;
  hasFavoritesMetric = false;
  loadingOverview = false;
  loadingHomeData = false;
  isShopifyBannerClosed = false;
  inactiveOffers: IOfferListItem[] = [];

  campaigns: ICampaign[] = [];

  activationEmailService = new ActivationEmailService();
  socialRewardService = new SocialRewardsService();
  offerService = new SpecialCoinOffersService();
  freeCoinsService: OfferFreeCoinsService = new OfferFreeCoinsService();
  referralService = new ReferralService();
  sellCoinsService = new SellCoinsService();
  businessService = new BusinessService();

  handleInvite() {
    if (this.$route.params.isDifferentAccount) {
      openCenterModal('invitationDifferentAccountModal', {
        inviteData: this.$route.params
      });

      return;
    }
  }

  async openUpdateSellCoinsModal() {
    const response = await this.sellCoinsService.getActiveCampaign();
    const activeCampaignData = response.data as Campaign;
    const automaticCampaignResponse = await this.sellCoinsService.getAutomaticCampaign();
    const automaticCampaignData = automaticCampaignResponse.data as Campaign;
    const business = this.$store.getters['business/getBusinessInfo'].business;

    if (
      !Object.keys(activeCampaignData).length ||
      Object.keys(automaticCampaignData).length ||
      !business.sellCoins ||
      (Object.keys(activeCampaignData).length &&
        activeCampaignData.incentiveValue &&
        activeCampaignData.incentiveValue >= business.coinRewardPercentage)
    ) {
      return;
    }

    const newCampaignData = {
      ...activeCampaignData,
      incentiveValue: parseFloat(business.coinRewardPercentage)
    };

    eventBus.$emit(
      'openSubModal',
      new ModalOptionsV2({
        componentToRender: 'sellCoinsRatioAdjustModal',
        hideCancelButton: false,
        icon: '',
        mobilePositionBottom: true,
        mobileFullScreen: false
      }),
      {
        activeCampaignData,
        newCampaignData,
        onSuccess: (message: string) => {
          eventBus.$emit('showNotification', message);
        }
      }
    );
  }

  verifyShopifyExtensionBannerStorage() {
    this.isShopifyBannerClosed =
      localStorage.getItem(SHOPIFY_EXTENSION_BANNER_CLOSED) === 'true';
  }

  mounted() {
    this.handleInvite();

    this.verifyShopifyExtensionBannerStorage();

    if (this.$route.params.resetBusinessOnboarding) {
      this.$store.dispatch('businessOnboarding/RESET_BUSINESS_ONBOARDING');
    }

    if (this.$route.query.error) {
      this.$notification(this.$route.query.error as string, 'error');
      this.$router.replace({ query: {} });
    }

    if (this.$route.params.showStartGuideHighlight) {
      setTimeout(() => {
        handleDispatchStartGuideHighlight();
      }, 1000); // 1s
    } else if (this.$route.params.showBillingLocationBenefitsModal) {
      setTimeout(() => {
        openCenterModal('billingLocationBenefitsModal', {
          mobilePositionBottom: true
        });
      }, 1000); // 1s
    }

    if (typeof this.$route.query.checkSellCoins !== 'undefined') {
      this.openUpdateSellCoinsModal();
    }

    logger.perfomanceTimerEnd('initial-loading');

    this.$store.dispatch('startGuide/GET_TASKS', () => {
      this.verifyUrl();
    });
    this.$store.dispatch('startGuide/GET_NEED_HELP');
    this.verifyUrlModal();
  }

  @Watch('teamMembers', { deep: true })
  onTeamMembersChange(newTeamMembers?: Array<any>) {
    if (newTeamMembers && newTeamMembers.length) {
      this.$store.dispatch('startGuide/GET_DISCOVER_MORE');
    }
  }

  getAllKeyDataCards(reportType: EBusinessReportType) {
    const filteredItems = Object.entries(defaultPerformanceHighlights)
      .map(([_, value]) => ({ ...value }))
      .filter(
        item =>
          !item.hideMetric &&
          (item.reportType ? item.reportType.includes(reportType) : true)
      );

    const allKeyDataStrings = filteredItems.flatMap(item => {
      if (!item.keyData) {
        return [];
      }
      if (Array.isArray(item.keyData)) {
        return item.keyData.filter(kd => typeof kd === 'string');
      }
      if (typeof item.keyData === 'string') {
        return [item.keyData];
      }
      return [];
    });

    const uniqueKeyDataStrings = [...new Set(allKeyDataStrings)];
    return uniqueKeyDataStrings;
  }

  get greetingText() {
    return `Hello${
      this.user.fullname ? `, ${this.user.fullname.split(' ')[0]}` : ''
    }!`;
  }

  get businessInfo() {
    return this.$store.getters['business/getBusinessInfo'].business || {};
  }

  get preferences() {
    return this.$store.getters[
      'startGuide/getPreferences'
    ] as StartGuidePreferences;
  }

  get tasks() {
    return this.$store.getters['startGuide/getTasks'] as StartGuideTask[];
  }

  get user() {
    const business = this.businessInfo;

    if (business) {
      return business.loggedInManager || {};
    }

    return {};
  }

  get startGuideCompleted() {
    return shouldAddSuccessStartGuide(EStartGuideTaskSlug.SUCCESS_MESSAGE);
  }

  get queryParameters() {
    return {
      from: this.period.start,
      to: this.period.end,
      slug: this.periodActive
    };
  }

  get teamMembers() {
    return this.businessInfo.teamMembers;
  }

  get showAnimationLoadingScreen() {
    return this.$route.params.showAnimationLoadingScreen;
  }

  get cachedHomeOverview() {
    return this.$store.getters['startGuide/getHomeOverview'];
  }

  get programStatus() {
    return this.$store.getters['business/getRewardStatus'] || {};
  }

  get businessIsHidden() {
    return this.businessInfo.status === 'hidden';
  }

  get showContent() {
    if (!this.businessIsHidden) return true;

    return !this.loadingOverview && !this.loadingHomeData;
  }

  get currentProvider() {
    return this.$store.getters['merchant/getCurrentProvider'] as IProvider;
  }

  get showShopifyExtensionBanner(): boolean {
    const { name, settings } = this.currentProvider || {};

    return (
      name === EBusinessProviders.SHOPIFY &&
      settings &&
      !settings.renderedOrderStatusTwismComponentAt &&
      !settings.renderedThankYouTwismComponentAt &&
      !this.isShopifyBannerClosed
    );
  }

  handleTaskTrigger(task: StartGuideTask, taskProps: any) {
    handleTaskTrigger(task, taskProps)({});
  }

  verifyUrlModal() {
    const { modal, ...rest } = this.$route.query;

    if (modal && typeof modal === 'string') {
      this.$router.replace({ query: undefined });

      if (!(modalMapper as any)[modal]) return;

      if (modal === 'rewardsProgramModal') {
        this.openRewardsProgramModal({
          operationType: this.businessInfo.operationType,
          ...rest
        });
        return;
      }

      eventBus.$emit(
        'openSubModal',
        new ModalOptionsV2({
          componentToRender: modal,
          hideCancelButton: false,
          icon: '',
          mobileFullScreen: false
        }),
        { ...rest }
      );
    }
  }

  verifyUrl() {
    const { startGuideTask, ...rest } = this.$route.query;

    if (startGuideTask) {
      const task = this.tasks.find(
        eachTask => eachTask.slug === startGuideTask
      );

      if (task) {
        this.handleTaskTrigger(task, rest);

        const query = Object.assign({}, this.$route.query);

        delete query.startGuideTask;
        delete query.initialStep;
        delete query.modal;

        this.$router.replace({ query });
      }
    }
  }

  async getOverviewGraph() {
    let allGraphs: any[] = [];
    try {
      this.chartLoading = true;

      const graphs = Object.entries(defaultPerformanceGraphs)
        .map(([_, value]) => ({
          ...value
        }))
        .filter((item: any) =>
          item.reportType
            ? item.reportType.includes(this.businessInfo.reportType)
            : true
        );

      graphs.forEach((item: any, index: number) => {
        allGraphs[index] = {
          ...PerformanceUtils.normalizedChartSeries(
            {
              labels: [],
              datasets: [item]
            },
            true,
            this.periodActive !== EPeriodPerformance.WEEK
          )[0],
          loaded: false
        };
        this.series = allGraphs;

        this.businessService
          .getHomeOverviewGrapth({
            ...this.queryParameters,
            graphType: item.slug
          })
          .then(({ data }) => {
            this.series[index] = {
              ...PerformanceUtils.normalizedChartSeries(
                {
                  ...data,
                  datasets: [data.datasets]
                },
                true,
                this.periodActive !== EPeriodPerformance.WEEK
              )[0],
              loaded: true
            };
            this.series = [...this.series];
          });
      });
    } finally {
      this.chartLoading = false;
    }
  }

  saveCache() {
    this.$store.dispatch('startGuide/SET_HOME_OVERVIEW', this.overviewData);
  }

  @Watch('periodActive')
  changedPeriod() {
    this.performanceData = {};
    this.getHomeData();
  }

  checkHasFavoritesMetric() {
    this.hasFavoritesMetric =
      this.performanceData &&
      this.performanceData.favoritesPerformanceOverview &&
      this.performanceData.favoritesPerformanceOverview.totalFavorites &&
      (this.performanceData.favoritesPerformanceOverview.totalFavorites
        .current >= 1 ||
        this.performanceData.favoritesPerformanceOverview.totalFavorites.last >=
          1);
  }

  async getReferralProgram() {
    try {
      if (!this.overviewData.hasActiveReferralProgram) throw '';
      this.referralService.disableInterception();
      return await this.referralService.getReferral();
    } catch (e) {
      return { data: false };
    }
  }

  async getHomeData(
    initialLoading?: boolean,
    cache?: boolean,
    checkHasFavoritesMetric?: boolean
  ) {
    this.period = PerformanceUtils.getPeriodBySlug(this.periodActive);
    try {
      this.loadingHomeData = !!initialLoading;
      if (
        cache &&
        this.cachedHomeOverview &&
        this.cachedHomeOverview.performance
      ) {
        this.overviewData = { ...this.cachedHomeOverview };
        if (checkHasFavoritesMetric) this.checkHasFavoritesMetric();
      } else if (initialLoading) {
        this.$showLoaderWithLocker();
      }
      const [{ data }] = await Promise.all([
        await this.businessService.getHomeOverview(this.queryParameters),
        this.getOverviewGraph()
      ]);
      const keyDataCards = this.getAllKeyDataCards(data.reportType);

      this.overviewData = { ...data };

      keyDataCards.map(dataType => {
        this.businessService
          .getHomeOverviewPerformance(
            data.reportType,
            dataType,
            this.queryParameters
          )
          .then(async data => {
            if (dataType.includes('Overview'))
              this.performanceData = {
                ...this.performanceData,
                [dataType]: data.data[dataType]
              };
            else
              this.performanceData = {
                ...this.performanceData,
                coinPerformanceOverview: {
                  ...this.performanceData.coinPerformanceOverview,
                  [dataType]: data.data[dataType]
                }
              };

            if (checkHasFavoritesMetric) this.checkHasFavoritesMetric();
          });
      });
      if (cache) this.saveCache();
    } finally {
      this.$hideLoader();
      this.loadingHomeData = false;
    }
  }

  @Watch('overviewData')
  async getOverview() {
    if (!this.overviewData || this.campaigns.length > 0) return;
    const returnDefaultValue: any = new Promise(resolve =>
      resolve({ data: { items: [] } })
    );

    const filterOfPeriod = {
      sort: 'firstcoin_campaign.createdAt:DESC',
      initialDateFreecoins: dayjs()
        .subtract(5, 'days')
        .startOf('day')
        .toISOString(),
      stoppedDateFreecoins: dayjs()
        .endOf('day')
        .toISOString()
    };

    this.loadingOverview = true;
    if (!this.showContent) this.$showLoaderWithLocker();
    const [
      { data: offers },
      { data: welcomeCoins },
      { data: referral },
      { data: sellCoins },
      { data: socialRewardsCampaigns },
      { data: emailAutomation }
    ] = await Promise.all([
      this.overviewData.hasOffer || this.businessIsHidden
        ? this.offerService.getOffers()
        : returnDefaultValue,
      this.overviewData.hasActiveWelcomeCoins
        ? this.freeCoinsService.listOfferFreeCoins('', {
            params: filterOfPeriod
          })
        : returnDefaultValue,
      this.getReferralProgram(),
      this.overviewData.hasActiveSellcoins
        ? this.sellCoinsService.listOfCampaigns()
        : returnDefaultValue,
      this.overviewData.hasActiveSocialRewards
        ? this.socialRewardService.getSocialRewardsCampaigns()
        : { data: false },
      this.overviewData.hasActiveCustomerAcquisition
        ? this.activationEmailService.getActivationEmail()
        : { data: { enabled: false } }
    ]);
    if (!this.showContent) this.$hideLoader();
    this.loadingOverview = false;

    const hideBothCoinsFeatures =
      (this.businessInfo.type === IBusinessType.ONLINE &&
        this.programStatus.rewardStatus !== 'active') ||
      this.inactiveBilling;

    const hideCoinsFeatures =
      this.programStatus.rewardStatus !== 'active' || this.inactiveBilling;

    this.campaigns = [
      {
        name: 'programStatus',
        data: [this.programStatus],
        hide: hideCoinsFeatures
      },
      {
        name: 'offer',
        data:
          offers && offers.items
            ? offers.items.filter(
                (item: any) =>
                  item.status === EOfferStatusEnum.ACTIVE ||
                  item.status === EOfferStatusEnum.INACTIVE
              )
            : []
      },
      {
        name: 'welcomeCoins',
        data:
          welcomeCoins && welcomeCoins.items
            ? welcomeCoins.items.filter((item: any) => item.status === 'active')
            : [],
        hide: hideBothCoinsFeatures
      },
      {
        name: 'referral',
        data: referral && referral.id ? [referral] : [],
        hide: hideCoinsFeatures
      },
      {
        name: 'sellCoins',
        data:
          sellCoins && sellCoins.items
            ? sellCoins.items.filter((item: any) => item.status === 'active')
            : [],
        hide: hideBothCoinsFeatures
      },
      {
        name: 'socialRewards',
        data: socialRewardsCampaigns ? socialRewardsCampaigns : [],
        hide: hideCoinsFeatures
      },
      {
        name: 'emailAutomation',
        data: emailAutomation.enabled ? [emailAutomation] : [],
        hide: hideCoinsFeatures
      }
    ].filter(item => item.data.length > 0 && !item.hide);

    this.inactiveOffers = offers.items.filter((item: any) => !item.image);
  }

  async reloadOffers() {
    this.$showLoader();
    try {
      const { data } = await this.offerService.getOffers();

      this.campaigns.filter(
        campaign => campaign.name === 'offer'
      )[0].data = data.items
        ? data.items.filter(
            (item: any) =>
              item.status === EOfferStatusEnum.ACTIVE ||
              item.status === EOfferStatusEnum.INACTIVE
          )
        : [];
      this.inactiveOffers = data.items.filter((item: any) => !item.image);
    } finally {
      this.$hideLoader();
    }
  }

  created() {
    this.getHomeData(true, true, true);
    this.getOverview();
  }

  onBannerClose() {
    localStorage.setItem(SHOPIFY_EXTENSION_BANNER_CLOSED, 'true');
    this.isShopifyBannerClosed = true;
  }
}
